"use strict";

import Vue from 'vue';
import axios from "axios";


//axios.defaults.baseURL = 'http://localhost:20377';
//axios.defaults.baseURL = 'https://api.dev.partica.online';
//axios.defaults.headers.common['Authorization'] = null;
axios.defaults.headers.post['Content-Type'] = 'application/json';

let config = {
	// baseURL: process.env.baseURL || process.env.apiUrl || ""
	// timeout: 60 * 1000, // Timeout
	// withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);

// pass _axios into service classes to use these interceptors.

_axios.interceptors.request.use(
	function (config) {
		//config.data = config.body;
		//console.log(config);
		// Do something before request is sent
		return config;
	},
	function (error) {
		// Do something with request error
		return Promise.reject(error);
	}
);

// Add a response interceptor
_axios.interceptors.response.use(
	function (response) {
		// Do something with response data
		return response;
	},
	function (error) {
		// Do something with response error
		return Promise.reject(error);
	}
);

Vue.prototype.$http = _axios;

Plugin.install = function (Vue, options) {
	Vue.axios = _axios;
	window.axios = _axios;
	Object.defineProperties(Vue.prototype, {
		axios: {
			get() {
				return _axios;
			}
		},
		$axios: {
			get() {
				return _axios;
			}
		},
	});
};

Vue.use(Plugin)
export default Plugin;
